export var SessionInteractionAction;
(function (SessionInteractionAction) {
    SessionInteractionAction["EmojiThrow"] = "emojiThrow";
})(SessionInteractionAction || (SessionInteractionAction = {}));
export const SessionInteractionActions = Object.values(SessionInteractionAction);
// export interface SessionInteractionPayload<A extends SessionInteractionAction> {
//     sessionId: string;
//     action: A;
//     payload: A extends keyof SessionInteractionPayloadMap ? SessionInteractionPayloadMap[A] : never;
// }
//# sourceMappingURL=common.js.map